import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEqual from 'lodash/isEqual';
import productPricingSelector, {
    isSameProductsCoupons,
    isAllItemsHaveCoupons,
} from '../../../selectors/Bundle/BundleProductPricingSelector';
import Pricing from './BundlePricing';
import { setBundleProductPricingAction } from '../../../actions/ProductPricingAction';
import { isFpacForBundle as isFpacForBundleSelector } from '../../../selectors/Bundle/BundleCommonSelector';

export class ProductPricing extends Component {
    static defaultProps = {
        pricingDetails: {},
        bundlePricingDetails: {},
        actions: {},
        productType: '',
        isSameCoupons: false,
        allItemsHaveCoupons: false,
        isFpacForBundle: false,
    };

    static propTypes = {
        pricingDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        bundlePricingDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        productType: PropTypes.string,
        isSameCoupons: PropTypes.bool,
        allItemsHaveCoupons: PropTypes.bool,
        isFpacForBundle: PropTypes.bool,
    };

    componentWillReceiveProps(nextProps) {
        /* istanbul ignore else */
        if (!isEqual(nextProps.bundlePricingDetails, this.props.bundlePricingDetails)) {
            this.props.actions.setBundleProductPricingAction(nextProps.bundlePricingDetails);
        }
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps.pricingDetails, this.props.pricingDetails);
    }

    render() {
        const {
            pricingDetails,
            productType,
            isSameCoupons,
            allItemsHaveCoupons,
            bundlePricingDetails,
            isFpacForBundle,
        } = this.props;
        return (
            <Pricing
                bundleLevelPricingDetails={bundlePricingDetails.calcBundleLevelPrice}
                pricingDetails={pricingDetails}
                productType={productType}
                isSameCoupons={isSameCoupons}
                allItemsHaveCoupons={allItemsHaveCoupons}
                isFpacForBundle={isFpacForBundle}
                isBundlePage
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    bundlePricingDetails: productPricingSelector(state),
    pricingDetails: productPricingSelector(state, ownProps.productOptions).calcChildLevelPrice[
        ownProps.productDetails.id
    ],
    isSameCoupons: isSameProductsCoupons(state),
    allItemsHaveCoupons: isAllItemsHaveCoupons(state),
    isFpacForBundle: isFpacForBundleSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ setBundleProductPricingAction }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductPricing);
